import { render, staticRenderFns } from "./BankAccountSetting.vue?vue&type=template&id=28a24908"
import script from "./BankAccountSetting.vue?vue&type=script&lang=js"
export * from "./BankAccountSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports